exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel > .table > tbody tr > th[data-v-20c06f54] {\n  border: 0;\n  background: #e6e9ed;\n  padding: 12px 10px;\n}\n.panel > .table > tbody tr > td[data-v-20c06f54] {\n  padding: 12px 10px;\n  vertical-align: middle;\n  vertical-align: middle;\n}\n.panel > .table > tbody tr > td[data-v-20c06f54]:last-child {\n  width: 105px;\n  text-align: right;\n}", ""]);

// exports
